var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 13,
    viewBox: "0 0 44 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0502 13.8364C40.8267 9.0243 36.7352 2.91782 36.102 2.48703C34.5864 1.00464 32.5846 0.122254 30.468 0.00354489H30.3171C27.8593 -0.066367 25.4854 0.900482 23.7758 2.66768L20.7107 5.55417L17.713 8.51608C16.087 10.2972 13.334 10.4474 11.5238 8.85377C9.71371 7.26017 9.51385 4.51024 11.0745 2.67165C10.7353 2.9918 10.4126 3.32906 10.1077 3.68212L2.5203 11.2636C0.844371 12.8933 -0.0688349 15.1528 0.0040519 17.4893C0.0769387 19.8258 1.1292 22.024 2.90345 23.546C2.96423 23.5968 3.03088 23.6401 3.10197 23.6751C1.80832 22.7307 1.16428 21.1329 1.4414 19.5554C1.71853 17.9779 2.8686 16.6953 4.40665 16.2484C5.9447 15.8015 7.60304 16.2681 8.68236 17.4515L11.4994 20.2983C11.7237 20.5186 14.2111 22.8234 14.4454 23.0279C15.8118 24.2282 17.4225 25.1175 19.1662 25.6345C20.8769 26.1612 22.7064 26.1612 24.4171 25.6345C26.6861 24.9079 28.4153 23.554 30.1741 22.0095C30.8359 21.4311 31.4857 20.8448 32.1236 20.2506L34.891 17.4554C36.0596 16.1726 37.8964 15.7399 39.5147 16.3663C41.133 16.9926 42.2 18.5491 42.2005 20.2844C42.2013 20.524 42.18 20.7633 42.137 20.999C41.9343 22.1029 41.3016 23.0811 40.3781 23.7188C40.4842 23.6793 40.5828 23.6223 40.6699 23.55C43.5028 21.1102 44.541 17.0604 43.0502 13.8364Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5403 2.3839C16.2524 1.11698 14.3238 0.759781 12.6675 1.48139C11.0113 2.20301 9.95969 3.85864 10.0106 5.66455C10.0614 7.47045 11.2045 9.06427 12.8988 9.69152C14.593 10.3188 16.4984 9.85359 17.713 8.51618L20.7107 5.55427L17.5403 2.3839Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0018 16.0837C36.8187 16.0826 35.6902 16.5816 34.8949 17.4575L32.1275 20.2527L32.0759 20.3043L33.3107 21.5391C33.867 22.1433 34.4534 22.7191 35.0676 23.2642C35.1828 23.3595 35.3019 23.4488 35.423 23.5342C35.6215 23.6672 35.8061 23.7903 36.0046 23.9074C36.2416 24.053 36.4907 24.1779 36.7491 24.2806C37.0996 24.4041 37.4675 24.4711 37.839 24.4792C38.7473 24.5084 39.6403 24.24 40.382 23.7149C41.3056 23.0772 41.9382 22.099 42.1409 20.9951C42.184 20.7594 42.2052 20.5201 42.2044 20.2805C42.2011 17.9617 40.3205 16.0837 38.0018 16.0837Z",
    fill: "#4C45D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69027 17.4574C7.53615 16.1892 5.72734 15.7494 4.11978 16.346C2.51222 16.9426 1.42833 18.4561 1.38101 20.1701C1.33369 21.8842 2.33243 23.4551 3.90462 24.1395C5.47682 24.8239 7.30714 24.4845 8.52947 23.282L11.5073 20.3042L8.69027 17.4574Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0552 15.6528V13.3917C23.0656 13.1093 22.9635 12.8345 22.7713 12.6274C22.5821 12.4315 22.2691 12.3336 21.8323 12.3336C21.6062 12.3319 21.3814 12.3681 21.1673 12.4408C20.9976 12.4944 20.8339 12.5656 20.6789 12.6532V15.6607H18.4158C18.1342 15.6513 17.8603 15.7533 17.6535 15.9446C17.4536 16.1326 17.3531 16.4462 17.3517 16.8856C17.3502 17.1117 17.3864 17.3365 17.4589 17.5507C17.5134 17.7201 17.5845 17.8837 17.6713 18.039H19.4283C19.7618 17.9834 20.395 17.7948 20.5578 17.1457C20.6258 16.8074 20.6663 16.4641 20.6789 16.1193V20.2883C20.6674 20.5755 20.7693 20.8558 20.9628 21.0684C21.1514 21.267 21.4651 21.3702 21.9018 21.3702C22.1299 21.3715 22.3562 21.3298 22.5688 21.2471C22.7674 21.1637 22.9381 21.0923 23.0552 21.0327V15.6727V15.6528Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2494 16.1412C26.168 15.9427 26.0965 15.77 26.037 15.6528H25.3064C24.6975 15.7332 24.1707 16.1166 23.9068 16.6712C23.682 17.0951 23.5341 17.5555 23.4701 18.0311H25.2945C25.5818 18.0427 25.862 17.9407 26.0747 17.7472C26.2758 17.5566 26.3764 17.243 26.3764 16.8062C26.3775 16.5784 26.3343 16.3526 26.2494 16.1412Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.348 12.6454C21.5033 12.5585 21.6669 12.4874 21.8363 12.4329C21.9443 12.3965 22.0553 12.3693 22.1679 12.3515C22.0568 12.3344 21.9447 12.3257 21.8324 12.3257C21.6062 12.3241 21.3814 12.3603 21.1673 12.4329C20.9976 12.4866 20.8339 12.5578 20.679 12.6454V15.6529C20.8567 15.6529 21.0272 15.5822 21.1527 15.4563C21.2782 15.3304 21.3485 15.1597 21.348 14.9819V12.6454Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0227 16.8778C18.0227 16.4397 18.1227 16.1261 18.3225 15.9368C18.5303 15.7458 18.8047 15.6439 19.0868 15.6529H18.4158C18.1342 15.6435 17.8603 15.7455 17.6535 15.9368C17.4536 16.1248 17.3531 16.4384 17.3517 16.8778C17.3502 17.1039 17.3864 17.3287 17.4589 17.5429C17.5134 17.7123 17.5845 17.8759 17.6713 18.0312H18.3404C18.2544 17.8755 18.1833 17.7119 18.1279 17.5429C18.0561 17.3286 18.0206 17.1038 18.0227 16.8778Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6318 21.0547C21.4383 20.8421 21.3363 20.5618 21.3479 20.2745V18.9246C21.3479 18.9246 21.3638 18.2536 21.3479 18.0313C21.2268 16.3458 20.6789 16.1116 20.6789 16.1116V20.2805C20.6673 20.5678 20.7693 20.848 20.9628 21.0607C21.1513 21.2592 21.465 21.3624 21.9018 21.3624C22.0102 21.3623 22.1185 21.353 22.2253 21.3346C22.0019 21.3097 21.7931 21.2112 21.6318 21.0547Z",
    fill: "url(#paint5_linear)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M25.9853 15.6528H25.3143C24.7054 15.7332 24.1786 16.1166 23.9148 16.6712C23.6871 17.0946 23.5366 17.555 23.4701 18.0311H24.1391C24.2054 17.5555 24.3546 17.0953 24.5798 16.6712C24.8448 16.1149 25.3742 15.7313 25.9853 15.6528V15.6528Z",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -11.1213,
    y1: 11.1481,
    x2: -0.349826,
    y2: 41.5492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ABBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#614AFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20.7485,
    y1: 9.9634,
    x2: 20.7485,
    y2: 1.04786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6120F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5677FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 11.5259,
    y1: 24.5207,
    x2: 11.5259,
    y2: 16.0836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5677FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6120F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 20.679,
    y1: 15.653,
    x2: 22.1679,
    y2: 15.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#614FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ABBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 17.3517,
    y1: 18.0315,
    x2: 19.0868,
    y2: 18.0315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#614FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ABBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 20.6789,
    y1: 21.3579,
    x2: 22.2253,
    y2: 21.3579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#614FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ABBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 23.476,
    y1: 18.0283,
    x2: 25.9853,
    y2: 18.0283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#614FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ABBFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo_only.9b6d3abb3c7edea119678c049c6f85a0.svg";
export { ForwardRef as ReactComponent };